import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carolina M.',
    age: '34 años',
    text: 'Creí que era mi edad o mi metabolismo. En la primera semana del protocolo, mis anillos dejaron de apretarme. He bajado 2 tallas de pantalón sin pisar el gimnasio.',
    rating: 5
  }, {
    name: 'Sofia R.',
    age: '41 años',
    text: 'Lo mejor no es solo cómo me veo, es cómo me siento. Ya no tengo esa pesadez después de comer. Es increíble lo que hace el estrés en el cuerpo.',
    rating: 5
  }, {
    name: 'Valentina T.',
    age: '29 años',
    text: 'Intenté keto, ayuno, todo. Nada funcionaba porque estaba estresada. Los ejercicios somáticos son mi parte favorita, me relajan muchísimo.',
    rating: 5
  }];
  return <section className="py-24 bg-white" data-id="element-240">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
        <div className="text-center mb-16" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-243">
            Mujeres reales, resultados reales
          </h2>
          <p className="text-charcoal-light" data-id="element-244">
            Únete a las miles de mujeres que han recuperado su bienestar.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-245">
          {testimonials.map((t, i) => <div key={i} className="bg-cream-50 p-8 rounded-2xl border border-beige-100 shadow-sm flex flex-col" data-id="element-246">
              <div className="flex gap-1 mb-4" data-id="element-247">
                {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-248" />)}
              </div>
              <p className="text-charcoal-light italic mb-6 flex-grow" data-id="element-249">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-250">
                <p className="font-bold text-charcoal" data-id="element-251">{t.name}</p>
                <p className="text-sm text-charcoal-light" data-id="element-252">{t.age}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}